<template>
  <b-col
    col
    cols="10"
    md="5"
    lg="3"
    class="mx-2 my-2 keyword-col"
    data-aos="fade-in"
    data-aos-duration="1500"
    data-aos-anchor-placement="top-bottom"
  >
    <router-link :to="'/consultations#' + link">
      <b-card class="keyword-card" href="">
        <b-img :src="logoSource" width="50px" />
        <h5 class="card-title">{{ keyword }}</h5>
        <p class="card-text">
          <slot />
        </p>
      </b-card>
    </router-link>
  </b-col>
</template>

<script>
export default {
  props: ["keyword", "logo", "link"],
  computed: {
    logoSource() {
      return require("../assets/icons_keyword/" + this.logo);
    },
  },
};
</script>

<style lang="stylus">
/* Import theme colors palette */
@import '../css/palette.styl';

.keyword-col a {
  text-decoration: None;
  color: black;
  }

.keyword-col a:hover {
  text-decoration: None;
  }

.keyword-col .keyword-card {
  background-color: transparent;
  height: 170px;
  border-color: $accentColor;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.keyword-col .keyword-card:hover {
  background-color: $accentColor !important;
  cursor: pointer;
  color: black;
}
</style>
